<template>
  <div>
    <center>
      <v-img height="100%" :src="require('@/assets/Icon/HRM.jpg')"></v-img>
      <v-container fluid>
        <v-card>
          <v-img
            @click="Home()"
            :lazy-src="require('@/assets/Icon/Back.jpg')"
            max-height="30"
            max-width="100"
            :src="require('@/assets/Icon/Back.jpg')"
          ></v-img>
        </v-card>
        <v-row>
          <v-col>
            <v-row>
              <v-col cols="12">
                <v-card-title class="lighten-5">
                  แจ้งปัญหา รถใช้งานในบริษัท
                  <v-icon color="#871B12">mdi-comment-alert </v-icon>
                </v-card-title>

                <v-col
          cols="12"
          sm="6"
        >
          <v-text-field
            solo
            dense
            label="ทะเบียนรถ"
            v-model="formAdd.carVehicle"
            clearable
          ></v-text-field>
        </v-col>

                <v-col class="d-flex" cols="12" sm="6">
                  <v-select
                    :items="['JAZZ',
                              'CITY',
                              'BRIO',
                              'BRIO AMAZE',
                              'BR-V',
                              'CR-V',
                              'HR-V',
                              'ACCORD',
                              'CIVIC',
                              'TOYOTA',
                              'ISUZU',
                              'HONDA WAVE',
                              'อื่นๆ']"
                    label="รุ่นรถ"
                    v-model="formAdd.carModel"
                    solo
                    :rules="[(v) => !!v || 'กรุณา เลือก 1 รายการ']"
                    dense
                  ></v-select>
                </v-col>
                <v-col class="d-flex" cols="12" sm="6">
                  <v-select
                    :items="['รถใช้งานทั่วไป',
                              'รถทดลองขับ',
                              'รถประจำตำแหน่ง']"
                    label="ประเภทรถใช้งาน"
                    v-model="formAdd.carType"
                    solo
                    :rules="[(v) => !!v || 'กรุณา เลือก 1 รายการ']"
                    dense
                  ></v-select>
                </v-col>
                <v-col class="d-flex" cols="12" sm="6">
                  <v-select
                    :items="['รถไม่สะอาด',
                              'แบตเตอร์รี่เสื่อม',
                              'ช่วงล่างแข็งกระด้าง',
                              'ยางแบน',
                              'สตาร์ทติดยาก']"
                    label="ปัญหาที่พบ"
                    v-model="formAdd.masProblemName"
                    solo
                    :rules="[(v) => !!v || 'กรุณา เลือก 1 รายการ']"
                    dense
                  ></v-select>
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    v-model="formAdd.problemDetail"
                    rows="3"
                    row-height="25"
                    label="อื่นๆ"
                    required
                    dense
                    outlined
                  ></v-textarea>
                </v-col>

                <v-btn small color="success" @click="addData(formAdd)">
                  บันทึกข้อมูล
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </center>
  </div>
</template>
<script>
import axios from 'axios' // api
import moment from 'moment' // แปลง date

export default {
  components: {
    name: 'Info',
    moment
  },
  data () {
    return {
      value: 1,
      PK: '',
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      session: this.$session.getAll(),
      formAdd: [],
      profile: [],
      dataItem: []
    }
  },
  async mounted () {
    this.dataReady = false
    this.profile = JSON.parse(localStorage.getItem('liff_info'))
    // await this.getData()
  },
  methods: {
    Home () {
      this.$router.push('/Liff/Home')
    },
    async getData () {
      this.dataReady = false
      this.dataItem = []
      const response = await axios.get(
        this.DNS_IP + '/master_problem/get?empCode=' + this.profile.empCode,
        {
          headers: {
            'Application-Key': this.$session.getAll().ApplicationKey
          }
        }
      )
      if (response.data) {
        this.dataItem = response.data[0]
        console.log('this.dataItem', this.dataItem)
      }
    },
    addData (dt) {
      this.dataReady = true
      console.log('dt', dt)
      let ds = {
        empCode: this.profile.empCode,
        CREATE_USER: this.profile.userName,
        LAST_USER: this.profile.userName,
        problemDetail: dt.problemDetail,
        carVehicle: dt.carVehicle,
        carType: dt.carType,
        carModel: dt.carModel,
        masProblemName: dt.masProblemName
      }
      console.log('ds', ds)
      this.addDataSubmit(ds)
    },
    async addDataSubmit (ds) {
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_problem/add",
          ds
        )
        .then(async (response) => {
          this.$swal('เรียบร้อย', 'บันทึกข้อมูล เรียบร้อย', 'success')
          this.dataReady = false
          await this.getData()
          await this.linenotify(ds)
          this.clearDataAdd()
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = false
          console.log('error function addDataGlobal : ', error)
        })
    },
    async linenotify (dt) {
      var massageNoti =
        'แจ้งปัญหา รถใช้งานในบริษัท' +
        '\nชื่อพนักงาน : ' +
        this.profile.empFull_NameTH +
        '\nแผนก : ' +
        this.profile.masDepartmentName +
        '\nสาขา : ' +
        this.profile.masBranchName +
        '\nปัญหาที่พบ : ' +
        dt.masProblemName +
        '\nรุ่นรถ : ' +
        dt.carModel +
        '\nทะเบียนรถ : ' +
        dt.carVehicle +
        '\nประเภทรถใช้งาน : ' +
        dt.carType
      let ds = {
        token: 'yc8wsCkux5MyRqTnsTl0QrbDnmoU55UXH5cyxTCeizQ', // token
        message: massageNoti // text
      }
      let url = this.DNS_IP + '/line/hrm_notify'
      await axios.post(url, ds)
    },
    clearDataAdd () {
      this.formAdd.problemDetail = null
      this.formAdd.carVehicle = ''
      this.formAdd.carType = null
      this.formAdd.carModel = null
      this.formAdd.masProblemName = null
    }
  }
}
</script>
<style scope>
.lighten-5 {
  font-family: Kanit;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 20px;

  color: #871b12;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/IssueProblemCars.vue